import { dispatch } from '../internal.js';
import * as actionTypes from './actionTypes.js';
export const select = (selected) => dispatch({ type: actionTypes.SELECT_EXCLUSIVECONTENT, payload: { selected } });
//# sourceMappingURL=actions.js.map